module.exports = __webpack_public_path__ + "static/media/42import-75.94415159.xlsx";